"use client";

import { signIn, useSession } from "next-auth/react";
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";
import { UserCog } from "lucide-react";
import { checkImpersonationGate, prepareImpersonation } from "@/actions/impersonation";
export function ImpersonationBanner() {
  const {
    data: session,
    update
  } = useSession();
  const router = useRouter();
  const [stopping, setStopping] = useState(false);
  const [starting, setStarting] = useState(false);
  const [error, setError] = useState(null);
  const [vpnAllowed, setVpnAllowed] = useState(null);
  useEffect(() => {
    if (session?.role !== "staff") return;
    void checkImpersonationGate().then(g => setVpnAllowed(g.allowed));
  }, [session?.role]);
  const handleStop = async () => {
    setStopping(true);
    try {
      await update({
        stopImpersonation: true
      });
      router.replace("/");
      router.refresh();
    } finally {
      setStopping(false);
    }
  };
  const handleStart = async () => {
    setStarting(true);
    setError(null);
    const result = await prepareImpersonation();
    if (!result.success) {
      setError(result.error);
      setStarting(false);
      return;
    }
    await signIn("whmcs", {
      callbackUrl: "/"
    });
  };
  if (session?.impersonatedBy) {
    return <div className="sticky top-0 z-50 flex items-center justify-between gap-3 bg-amber-500 px-4 py-2 text-amber-950 shadow-md">
        <div className="flex items-center gap-2 text-sm font-medium">
          <UserCog className="h-4 w-4 shrink-0" />
          <span>
            Impersonating <strong>{session.user?.email}</strong> as{" "}
            <strong>{session.impersonatedBy}</strong>
          </span>
        </div>
        <button type="button" onClick={handleStop} disabled={stopping} className="rounded bg-amber-950 px-3 py-1 text-xs font-medium text-amber-50 hover:bg-amber-900 disabled:opacity-50">
          {stopping ? "Stopping…" : "Stop impersonating"}
        </button>
      </div>;
  }
  if (session?.role === "staff") {
    return <div className="sticky top-0 z-50 flex items-center justify-between gap-3 bg-sky-600 px-4 py-2 text-sky-50 shadow-md">
        <div className="flex flex-col gap-0.5 text-sm font-medium sm:flex-row sm:items-center sm:gap-2">
          <div className="flex items-center gap-2">
            <UserCog className="h-4 w-4 shrink-0" />
            <span>
              Staff mode: <strong>{session.user?.email}</strong>
            </span>
          </div>
          {error && <span className="text-xs text-red-100">{error}</span>}
        </div>
        {vpnAllowed === false ? <span className="text-xs text-sky-100">
            VPN required for impersonation
          </span> : <button type="button" onClick={handleStart} disabled={starting || vpnAllowed === null} className="rounded bg-sky-950 px-3 py-1 text-xs font-medium text-sky-50 hover:bg-sky-900 disabled:opacity-50">
            {starting ? "Redirecting…" : "Impersonate customer (WHMCS)"}
          </button>}
      </div>;
  }
  return null;
}